import { offsetPosition } from "slotworks/utils/position-offset-calculator";
import ImageDimSymbolBehaviour from "./image-dim-symbol-behaviour";

/**
 * Same as ImageDimSymbolBehaviour except it draws a graphical box
 */
export default class BoxDimSymbolBehaviour extends ImageDimSymbolBehaviour {

    public static color: number = 0x000000;
    public static opacity: number = 0.5;

    public behaviourName: string = "BoxDim";

    protected showDimTexture() {
        if (!this.behaviourSprite.children.length) {
            const graphics = new PIXI.Graphics();
            graphics.beginFill(BoxDimSymbolBehaviour.color, BoxDimSymbolBehaviour.opacity);
            graphics.drawRect(0, 0, 1, 1);
            this.behaviourSprite.addChild(graphics);
        }

        this.behaviourSprite.parent.addChildAt(this.behaviourSprite, 0);
        this.behaviourSprite.visible = true;

        this.updateTransform();
    }

    protected offsetPosition() {
        const positions = [`${this.symbol.symbolId}_boxdim`, "boxdim", this.symbol.symbolId, "static"];
        offsetPosition(this.behaviourSprite, this.matrixLayer, "symbol_1_1", positions);
    }
}
